import { render, staticRenderFns } from "./BuscadorPedido.vue?vue&type=template&id=46cb68de&"
import script from "./BuscadorPedido.vue?vue&type=script&lang=js&"
export * from "./BuscadorPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports